












import { computed, defineComponent } from '@nuxtjs/composition-api';
import type { PropType } from 'vue';

import { useActivePerformances } from '@/composables/performances';

export default defineComponent({
  name: 'RelatedPerformances',
  props: {
    currentPerformanceId: {
      type: String,
      default: '',
      required: true,
    },
    performanceTags: {
      type: Array as PropType<{ id: string, title: string }[]>,
      default: () => [],
    },
  },
  setup: (props) => {
    const { performances, performancesLoading } = useActivePerformances({
      limit: 8,
      performanceTags: props.performanceTags.map(tag => tag.id),
    });

    const filteredPerformances = computed(() => performances.value.filter(performance => performance.id !== props.currentPerformanceId));
    const subtitle = computed(() => props.performanceTags.map(tag => tag.title).join(', '));

    return ({
      performances,
      performancesLoading,
      filteredPerformances,
      subtitle,
    });
  },
});
